import { render, staticRenderFns } from "./merchantItem.vue?vue&type=template&id=61ee147b&"
import script from "./merchantItem.vue?vue&type=script&lang=js&"
export * from "./merchantItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports